module.exports = __webpack_public_path__ + "img/toilet-paper.97336e84.svg";